import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoUser } from 'app/shared/models/security/dto-user.model';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoUserRole } from 'app/shared/models/security/dto-user-role.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
    selector: 'app-modal-user-role',
    templateUrl: './modal-user-role.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalUserRoleComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formUserRole: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private user: IDtoUser;
    /**Catalogos */
    private catalogSystems: Observable<ISelect[]>;
    private catalogModules: Observable<ISelect[]>;
    private catalogRoles: Observable<ISelect[]>;
    /**Listas */
    private userRoles = new Array() as IDtoUserRole[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableUserRoles: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private identityService: IdentityService
        , private configGeneral: AppConfig) {
        this.initializeFormUserRole();
        this.configToast = this.configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.catalogSystems = this.identityService.getCatalogSystems();
        this.getRolesByUser();
    }
    private initializeFormUserRole() {
        this.formUserRole = this.formBuilder.group({
            systemId: [null, [Validators.required]],
            moduleId: [null, [Validators.required]],
            roleId: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.formUserRole.valid) {
            this.save();
        } else {
            this.snotifyService.error('Capture toda la información requerida para poder continuar'
                , 'Validación', this.configToast);
        }
    }
    private save(): void {
        const data = this.formUserRole.value as IDtoUserRole;
        data.userId = this.user.id;
        this.identityService.addUserRole(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getRolesByUser();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getRolesByUser(): void {
        this.identityService.getRolesByUser(this.user.id)
            .subscribe(
                (x) => {
                    this.userRoles = x.data as IDtoUserRole[];
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getCatalogModulesBySystem(systemId: string): void {
        this.formUserRole.get('moduleId').reset();
        this.formUserRole.get('roleId').reset();
        this.catalogRoles = null;
        this.catalogModules = this.identityService.getCatalogModulesBySystem(Number(systemId));
    }
    private getCatalogRoleByModule(moduleId: string): void {
        this.formUserRole.get('roleId').reset();
        this.catalogRoles = this.identityService.getCatalogRoleByModule(moduleId);
    }
    private delete(item: IDtoUserRole): void {
        this.identityService.deleteUserRole(item)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getRolesByUser();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
